import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import styled from "styled-components";
import { selectActive } from "../common/slices/location";
import { fetchScopeOfWork, modifyScopeOfWork, selectScopeOfWorkById } from "../common/slices/scopeOfWork";
import { ErrorContext } from "../ErrorContext";
import { BlackButton, ButtonBase, LightButton } from "./Buttons";
import FormTextInput from "./FormTextInput";
import Modal from "./Modal";
import Row from "./Row";
import { H1, P, P2 } from "./Typography";

const Attribute = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const ModalEditScopeOfWork = ({ scopeId, onClose }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const locationId = useSelector(selectActive);
    const customer = useSelector(state => selectScopeOfWorkById(state, scopeId));

    useEffect(() => {
        (async () => {
            try {
                if (scopeId && locationId) {
                    await dispatch(fetchScopeOfWork(scopeId, locationId));
                }
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to fetch scope of work", forSupport: ex.message })
            }
        })()
    }, [scopeId, locationId])

    const {
        control,
        formState: { errors, isSubmitting, isValid },
        handleSubmit
    } = useForm({
        values: customer,
    })

    const formProps = { control, errors, locationId }

    const onSave = async (data) => {
        try {
            await dispatch(modifyScopeOfWork(data));
            onClose();
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to save scope of work", forSupport: ex.message })
        }
    }

    return (
        <Modal show size="60%" zindex='1200'>
            <Row>
                <H1>Scope of Work</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>

            <Attribute>
                <P2>QuickBooks ID</P2>
                <P>{customer?.id}</P>
            </Attribute>
            <Row>
                <FormTextInput {...formProps} name="name" label="Name" placeholder="Enter name" rules={{ required: true }} />
                <FormTextInput {...formProps} name="fullName" label="Full Name" placeholder="Enter full name" rules={{ required: true }} />
            </Row>
            <Row>
                <BlackButton onClick={handleSubmit(onSave)} disabled={isSubmitting || !isValid}>Save</BlackButton>
                <LightButton onClick={onClose} disabled={isSubmitting}>Cancel</LightButton>
            </Row>
        </Modal>
    );
};

export default ModalEditScopeOfWork;
